<template>
    <div>

        <!-- Modal 按鈕 -->
        <b-button class="add-note"
                  v-b-modal="modalID"
                  variant="success" >
            <i class="fa fa-hashtag"></i> ID 加鹽小廚房
        </b-button>



        <!-- Modal 內容 -->
        <b-modal hide-header-close ok-only size="md"
                :id="modalID" ref="modal"
                header-text-variant="light"
                header-bg-variant="teal" >
            <!-- header -->
            <div slot="modal-header">HashID 迷你加鹽廚房</div>

            <div>

                <div>
                    <div class="block-sm">{{ $t('n.device') }} 分類 *</div>
                    <div class="block-sm" v-if="deviceType == 'gateway'">

                        <b-form-radio-group v-model="device.type" :plain="true" buttons>
                            <b-form-radio :value="device.type" button-variant="outline-warning">
                                <i :class="$tools.style.classIcon(device.type, 'block-text')"></i>{{ $t('n.gateway') }} {{ device.type }}
                            </b-form-radio>
                        </b-form-radio-group>

                    </div>
                    <div class="block-sm" v-else-if="deviceType == 'accesspoint'">

                        <b-form-radio-group v-model="device.type" :plain="true" buttons>
                            <b-form-radio :value="device.type" button-variant="outline-success">
                                <i :class="$tools.style.classIcon(device.type, 'block-text')"></i>{{ $t('n.accesspoint') }} {{ device.type }}
                            </b-form-radio>
                        </b-form-radio-group>

                    </div>
                    <div class="block-sm" v-else>

                        <b-form-radio-group v-model="device.type" :plain="true" buttons stacked>
                            <b-form-radio v-for="(_deviceType, idx_dt) in admin_DeviceType_List" :key="idx_dt"
                                            :value="_deviceType.type" :button-variant="'outline-' + _deviceType.variant">
                                <i :class="$tools.style.classIcon(_deviceType.type, 'block-text')"></i>{{ $t('n.' + _deviceType.type) }} ( {{ _deviceType.type }} )
                            </b-form-radio>
                        </b-form-radio-group>

                    </div>
                </div>

                <b-row v-if="salt_map">
                    <b-col md="8">
                        <b-form-select v-model="device.version" class="mb-3">
                            <option v-for="(version, key, idx_v) in salt_map.options" :key="idx_v" :value="key">
                                {{ key }} - {{ version.name }}
                            </option>
                        </b-form-select>
                    </b-col>

                    <b-col md="6">
                        <b-input-group class="mb-3">
                            <b-input-group-prepend>
                                <b-input-group-text><i class="fa fa-diamond"></i>ID *</b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input type="number" step="1" min="1" max="9999" class="form-control"
                                            v-model.number="device.id" />
                        </b-input-group>
                    </b-col>

                    <b-col md="8">
                        <b-input-group class="mb-3">
                            <b-input-group-prepend>
                                <b-input-group-text><i class="fa fa-diamond"></i>Result Hash ID</b-input-group-text>
                            </b-input-group-prepend>

                            <b-input-group-text>{{ getResultHashID }}</b-input-group-text>

                        </b-input-group>
                    </b-col>
                </b-row>


                <div v-if="isExist">
                    <b-alert show variant="danger" class="text-center"><i class="fa fa-warning faa-flash animated"></i>此裝置 hashid 已經存在 !!</b-alert>
                </div>
            </div>


            <div slot="modal-footer" class="w-100">
                <div class="float-left">
                    <!-- HashTag -->
                    <i class="fa fa-hashtag"></i> {{ device.type }} <span v-if="device.id">- {{ device.id }} - {{ device.hashid }}</span>

                </div>

                <b-btn class="btn-agri float-right" variant="success"   @click="emitValue()" :disabled="checkDisabled">{{ $t('menu.confirm') }}</b-btn>
                <b-btn class="btn-agri float-right" variant="secondary" @click="closeModal()">{{ $t('menu.cancel') }}</b-btn>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import SaltMap from '@/common/salt-map'
import Hashids from 'hashids'

export default {
    props: {
        deviceType: {
            type: String,
            required: true,
        },
        existDevices: {
            type: Array,
            default: function () { return [] }
        },
    },
    data () {
        return {
            modalID: 'hashid-selector-modal-',
            salt_map: undefined,
            isExist: false,

            device: {
                version: undefined,

                id: undefined,
                hashid: undefined,
                type: undefined,
            },
        }
    },
    mounted () {

        this.device.type = this.deviceType
        this.getSaltMap( this.device.type )

    },
    computed: {
        ...mapState({
            'admin_DeviceType_List': state => state.device.list_deviceTypes,
        }),

        getResultHashID ()
        {
            if ( this.salt_map && this.device.version && this.device.id )
            {
                let _salt = this.salt_map.options[ this.device.version ].salt;
                let _hashLength = this.salt_map.options[ this.device.version ].hashLength;
                let _allCharacter = this.salt_map.options[ this.device.version ].allCharacter;

                this.device.hashid = this.device.version + this.$tools.data.getHasdID( _salt, _hashLength, this.device.id, _allCharacter );

                this.checkExist(this.device.hashid);

                return this.device.hashid
            }
            else return '??????'
        },

        checkDisabled()
        {
            if (this.device.hashid == undefined) return true
            if (this.isExist) return true
            return false;
        },

    },
    watch: {

        'deviceType': function (val, oldVal)
        {
            if (val)
            {
                this.device.type = val
            }
        },

        'device.type': function (val, oldVal)
        {
            if (val)
            {
                this.getSaltMap( val )
            }
        },

    },
    methods: {

        checkExist (hashid)
        {
            let _checkExist = false

            this.existDevices.forEach( _device => {

                if ( _device.hashid && _device.hashid == hashid )
                {
                    _checkExist = true
                }
            })
            this.isExist = _checkExist
        },

        emitValue ()
        {
            this.$emit('result-value', { id: this.device.id, hashid: this.device.hashid, type: this.device.type });
            this.closeModal()
        },

        closeModal ()
        {
            this.$refs.modal.hide()
        },

        getSaltMap (deviceType)
        {
            if (deviceType == 'gateway')
            {
                this.salt_map = SaltMap['gateway'][ deviceType ]
                this.device.version = this.salt_map.default
            }
            else if (deviceType == 'accesspoint')
            {
                this.salt_map = SaltMap['accesspoint'][ deviceType ]
                this.device.version = this.salt_map.default
            }
            else
            {
                this.salt_map = SaltMap['device'][ deviceType ]
                this.device.version = this.salt_map.default
            }
        },

    }
}
</script>

<style lang="scss" scoped>

</style>
